var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border"},[_c('canvas',{ref:"canvas",attrs:{"width":"250","height":"250"}}),_c('div',{ref:"black",staticClass:"black"}),_c('p',{staticClass:"marker"},[_vm._v(_vm._s(_vm.userName))])])}
var staticRenderFns = []

export { render, staticRenderFns }